import { Volume2, VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  useKioskAudioMuted,
  useToggleKioskAudioMuted,
} from "@/features/audio/kiosk-audio";
import { useFeatureFlags } from "@/lib/runtime-config";

/** Speaker toggle next to the language picker; only while `kiosk.audio` is on. */
export function AudioMuteButton() {
  const enabled = useFeatureFlags().audio;
  if (!enabled) {
    return null;
  }
  return <AudioMuteToggle />;
}

function AudioMuteToggle() {
  const { t } = useTranslation();
  const { muted } = useKioskAudioMuted();
  const toggle = useToggleKioskAudioMuted();
  const Icon = muted ? VolumeX : Volume2;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={muted ? t("Hang bekapcsolása") : t("Hang némítása")}
      aria-pressed={muted}
      data-testid="audio-mute-button"
      className="flex h-[70px] w-[70px] items-center justify-center rounded-full border-4 border-white"
    >
      <Icon color="white" className="h-[44px] w-[44px]" />
    </button>
  );
}
